import styleSlider from './../styles/slider.scss';
import React, { useState } from 'react';
import { Carousel, CarouselItem, CarouselControl } from 'reactstrap';
const Slider = (props) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [animating, setAnimating] = useState(false);

  const next = () => {
    if (animating) return;
    const nextIndex = activeIndex === props.items.length - 1 ? 0 : activeIndex + 1;
    setActiveIndex(nextIndex);
  };
  const previous = () => {
    if (animating) return;
    const nextIndex = activeIndex === 0 ? props.items.length - 1 : activeIndex - 1;
    setActiveIndex(nextIndex);
  };
  const goToIndex = (newIndex) => {
    if (animating) return;
    setActiveIndex(newIndex);
  };

  const slides = props.items.map((item) => {
    return (
      <CarouselItem
        onExiting={() => setAnimating(true)}
        onExited={() => setAnimating(false)}
        key={item.key}
      >
        <img src={item.src} alt={item.altText} className="img-fluid w-100 lazyload" />
      </CarouselItem>
    );
  });

  return (
    <div className="slider-1">
      <Carousel
        cssModule={styleSlider}
        activeIndex={activeIndex}
        next={next}
        previous={previous}
        pause={props.autoplay}
      >
        {slides}
        <CarouselControl direction="prev" directionText="" onClickHandler={previous} />
        <CarouselControl direction="next" directionText="" onClickHandler={next} />
      </Carousel>
    </div>
  );
};

export default Slider;
